import React, { useState, useEffect } from 'react';
import { LuMegaphone, LuSparkles } from 'react-icons/lu';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../shared/firebase';

export default function ScrollNewsTicker({ onSelectSection = () => { } }) {
  const [scrollNews, setScrollNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function fetchScrollNews() {
      try {
        setLoading(true);
        let snapshot = await getDocs(collection(db, 'scrollnews')).catch(() => null);
        if (!snapshot || snapshot.empty) {
          snapshot = await getDocs(collection(db, 'scroll_news')).catch(() => null);
        }

        const items = [];
        if (snapshot && !snapshot.empty) {
          snapshot.forEach((doc) => {
            const data = doc.data();
            const text = data.news || data.title || data.text || data.content || '';
            const order = typeof data.order === 'number' ? data.order : 999;
            if (text && text.trim() !== '') {
              items.push({
                id: doc.id,
                text: text.trim(),
                order
              });
            }
          });
        }

        items.sort((a, b) => a.order - b.order);

        // Fallback default if collection is empty
        if (items.length === 0) {
          items.push({
            id: 'fallback-1',
            text: "As part of 10th anniversary celebration of the CSI Diocese of Malabar, 10 houses are constructed and handed over to the homeless within the diocese through 'Sanketham Housing Project.'",
            order: 1
          });
        }

        if (isMounted) {
          setScrollNews(items);
        }
      } catch (err) {
        console.error("Error fetching scrollnews:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchScrollNews();
    return () => { isMounted = false; };
  }, []);

  if (scrollNews.length === 0 && !loading) return null;

  return (
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 my-4 w-full">
      <div className="rounded-[22px] bg-gradient-to-r from-[#7B1E3A] via-[#842343] to-[#65172F] text-white p-2 sm:p-2.5 px-3.5 sm:px-5 shadow-[0_6px_25px_rgba(123,30,58,0.12)] border border-[#9E2F50]/50 flex items-center gap-3 relative overflow-hidden select-none">
        
        {/* Left Ticker Label / Badge */}
        <div className="flex items-center gap-2 bg-white/15 backdrop-blur-xs px-3 py-1.5 rounded-xl border border-white/20 shrink-0 shadow-2xs">
          <LuMegaphone className="w-3.5 h-3.5 text-[#D4A64A] animate-pulse" />
          <span className="font-sans font-bold text-[10px] sm:text-[11px] uppercase tracking-[0.16em] text-[#F3E5D8]">
            DIOCESAN UPDATES
          </span>
        </div>

        {/* Scrolling News Track with Soft Fade Edges */}
        <div
          className="relative overflow-hidden flex-1 group cursor-pointer"
          style={{
            maskImage: 'linear-gradient(to right, transparent 0%, black 3%, black 97%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 3%, black 97%, transparent 100%)'
          }}
          onClick={() => onSelectSection('news')}
        >
          <div className="whitespace-nowrap animate-marquee flex items-center gap-8 group-hover:[animation-play-state:paused]">
            {scrollNews.concat(scrollNews).map((item, idx) => (
              <div key={idx} className="inline-flex items-center gap-4 text-xs sm:text-[13px] font-medium text-white/95">
                <span>{item.text}</span>
                <span className="text-[#D4A64A] font-serif text-sm opacity-80">✦</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Action Hint */}
        <button
          onClick={() => onSelectSection('news')}
          className="hidden sm:inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#D4A64A] hover:text-white transition-colors shrink-0 bg-white/10 hover:bg-white/20 border border-white/10 px-3 py-1.5 rounded-xl cursor-pointer"
        >
          <span>View News</span>
          <LuSparkles className="w-3 h-3 text-[#D4A64A]" />
        </button>

      </div>
    </div>
  );
}
